<template>
  <div class="my-3">
    <div class="rounded-md w-full bg-red-100 px-4 py-3 text-sm text-red-700">
      {{ prop.errorMessage }}
    </div>
  </div>
</template>
<script setup lang="ts">
const prop = defineProps<{
  errorMessage: string;
}>();
</script>
